import { Pipe, PipeTransform } from '@angular/core';

const WEFIT_PROVIDER_LOGO_BASE = 'https://lms2.wefitgroup.com/assets/img_provider/';

@Pipe({
  standalone: true,
  name: 'providerLogo'
})
export class ProviderLogoPipe implements PipeTransform {

  transform(providerId: number | null): string | null {
    if (!providerId) { return null; }
    return `${WEFIT_PROVIDER_LOGO_BASE}${providerId}.png`;
  }

}
